/**
 * @generated SignedSource<<8fbbc6ad6b725977972fb59100a1e54d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrainSearchSidebarListPaginationQuery$variables = {
  after?: string | null;
  first?: number | null;
  id: string;
};
export type BrainSearchSidebarListPaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"BrainSearchSidebarList_PaginationFragment">;
  } | null;
};
export type BrainSearchSidebarListPaginationQuery = {
  response: BrainSearchSidebarListPaginationQuery$data;
  variables: BrainSearchSidebarListPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v6 = [
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v8 = [
  {
    "alias": "nonNullProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v5/*: any*/),
  (v7/*: any*/)
],
v9 = [
  {
    "alias": "nullableProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v5/*: any*/),
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrainSearchSidebarListPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "FragmentSpread",
            "name": "BrainSearchSidebarList_PaginationFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrainSearchSidebarListPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "BrainSearchNodeConnection",
                "kind": "LinkedField",
                "name": "brainSearches",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BrainSearchNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BrainSearch",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasViewerBookmarked",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsage",
                            "kind": "LinkedField",
                            "name": "contentUsage",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "organizationId",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": (v6/*: any*/),
                                "type": "Organization",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "nonNullProductId",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                  },
                                  (v5/*: any*/),
                                  (v7/*: any*/)
                                ],
                                "type": "Product",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v8/*: any*/),
                                "type": "Event",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v9/*: any*/),
                                "type": "Comment",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v9/*: any*/),
                                "type": "Feed",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v9/*: any*/),
                                "type": "Post",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "nullableProductIdString",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "productId",
                                    "storageKey": null
                                  },
                                  (v5/*: any*/),
                                  (v7/*: any*/)
                                ],
                                "type": "ContentUsage",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v9/*: any*/),
                                "type": "ChatChannel",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v9/*: any*/),
                                "type": "Dashboard",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v8/*: any*/),
                                "type": "AssignmentSubmission",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v6/*: any*/),
                                "type": "PathwayGroup",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v6/*: any*/),
                                "type": "BrainSearch",
                                "abstractKey": null
                              }
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfoObjectType",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v2/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "BrainSearchSidebarList__brainSearches",
                "kind": "LinkedHandle",
                "name": "brainSearches"
              }
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cf4bf1920f1de7dfd067b7f157b06793",
    "id": null,
    "metadata": {},
    "name": "BrainSearchSidebarListPaginationQuery",
    "operationKind": "query",
    "text": "query BrainSearchSidebarListPaginationQuery(\n  $after: String\n  $first: Int\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...BrainSearchSidebarList_PaginationFragment_2HEEH6\n    id\n  }\n}\n\nfragment BookmarkButtonBrainSearchFragment on BrainSearch {\n  id\n  hasViewerBookmarked\n}\n\nfragment BrainSearchMoreActionsButtonFragment on BrainSearch {\n  id\n  hasViewerBookmarked\n  contentUsage {\n    id\n  }\n  ...usePermissionsFragment\n  ...DeleteBrainSearchButtonFragment\n  ...BookmarkButtonBrainSearchFragment\n}\n\nfragment BrainSearchSidebarList_PaginationFragment_2HEEH6 on OrganizationMembership {\n  id\n  brainSearches(first: $first, after: $after) {\n    edges {\n      node {\n        ...BrainSearchTitleFragment\n        id\n        createdAt\n        ...BrainSearchMoreActionsButtonFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      startCursor\n      endCursor\n      hasNextPage\n      hasPreviousPage\n    }\n  }\n}\n\nfragment BrainSearchTitleFragment on BrainSearch {\n  id\n  title\n}\n\nfragment DeleteBrainSearchButtonFragment on BrainSearch {\n  id\n  organizationId\n  contentUsage {\n    id\n  }\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "c37ab1fe9777119e77c1ba9ef4e5bfc3";

export default node;
